// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"antd-pro-components-common-usergroup-add-outlined-style-tooltip"};